import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TrainingStatusList from "../Components/TrainingsStatusList";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import "./TrainingsStatus.css";

function TrainingsStatus() {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState("");
  const [categories, setCategories] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/users/status/`,
        data: {
          organization: state.organization,
          role: state.role,
          userId: state.userId,
          filter: filter,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setUsers(response.data.users);
      setCategories(response.data.categories);
      setIsLoading(false);
    }
    fetch();
  }, [state.organization, state.token, state.role, state.userId, filter]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={9} className="trainings">
            <h2>{t("Capacitaciones.Capacitacion.DetalleCapacitaciones")}</h2>
          </Col>
        </Row>
        {state.role === "admin" || state.role === "root" ? (
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Select
                  className="mb-3"
                  name="categories"
                  onChange={(e) => setFilter(e.target.value)}
                  value={filter}
                >
                  <option value={""}>{t("Capacitaciones.Todos")}</option>
                  {categories.map((item) => (
                    <option key={item._id} id={item._id} value={item._id}>
                      {state.language === "es" ? item.name : item.name_english}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        <Row>
          <TrainingStatusList users={users} />
        </Row>
      </Container>
    );
  }
}

export default TrainingsStatus;
